import { Either } from '@ajtec/either-typescript';
import { IRecommendReq } from '../entities/recommend.model';
import { IHomeRepository } from '../repositories/home-repository';

export class SendRecommendation {
	repository: IHomeRepository;

	constructor(homeRepository: IHomeRepository) {
		this.repository = homeRepository;
	}

	call(params: IRecommendReq): Promise<Either<string, string>> {
		return this.repository.sendRecommendation(params);
	}
}
